var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.60545 2.11996C5.24844 1.87182 4.81439 1.72934 4.24002 1.72934C2.53629 1.72934 1.44223 3.07982 1.44223 4.66822C1.44223 6.20109 2.32849 7.59691 3.51355 8.76103C4.62327 9.85112 5.94698 10.6896 6.92064 11.2095C7.89431 10.6896 9.21801 9.85112 10.3277 8.76103C11.5128 7.59691 12.3991 6.20109 12.3991 4.66822C12.3991 3.07982 11.305 1.72934 9.60126 1.72934C9.0269 1.72934 8.59284 1.87182 8.23583 2.11996C7.87556 2.37037 7.58265 2.73605 7.30482 3.20084C7.3048 3.20087 7.30478 3.2009 7.30476 3.20094L7.16313 3.11628L5.60545 2.11996ZM5.60545 2.11996C5.96572 2.37036 6.25862 2.73603 6.53645 3.20081L5.60545 2.11996ZM6.71712 12.116L6.71803 12.1165C6.78081 12.1484 6.85024 12.165 6.92064 12.165C6.99105 12.165 7.06047 12.1484 7.12326 12.1165L7.12416 12.116C8.16339 11.5798 9.6811 10.6542 10.9558 9.40207C12.2281 8.15228 13.2934 6.54546 13.2934 4.66822C13.2934 2.65914 11.8204 0.835 9.60126 0.835C8.37739 0.835 7.53664 1.4201 6.92064 2.21688C6.30464 1.4201 5.4639 0.835 4.24002 0.835C2.02091 0.835 0.547891 2.65914 0.547891 4.66822C0.547891 6.54546 1.61322 8.15228 2.88549 9.40207L3.00112 9.28436L2.88549 9.40207C4.16018 10.6542 5.6779 11.5798 6.71712 12.116Z",
    fill: "#42328A",
    stroke: "#42328A",
    strokeWidth: 0.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.bd9819e9c8bb0f0b48b99c8d29bebffb.svg";
export { ForwardRef as ReactComponent };